// // src/components/OrderList/orderUtils.js

// export function parseChoice(rawChoice) {
//   try {
//     if (Array.isArray(rawChoice)) return rawChoice;
//     if (typeof rawChoice === "string") return JSON.parse(rawChoice || "[]");
//   } catch (e) {
//     console.warn("parseChoice error:", e);
//   }
//   return [];
// }

// export function joinName(...parts) {
//   return parts
//     .map((x) => String(x || "").trim())
//     .filter(Boolean)
//     .join(" ");
// }

// export function getStatus(order = {}) {
//   return order?.statusFlow?.current || order?.status || "Очікує підтвердження";
// }

// export function getTtn(order = {}) {
//   return order?.ttn || order?.logistics?.ttn || order?.delivery?.ttn || "";
// }

// export function getUserCategory(order = {}) {
//   return order?.userCategory || order?.userSnapshot?.category || "";
// }

// export function isBusinessPartnerOrder(order = {}) {
//   const c = String(getUserCategory(order)).toLowerCase();
//   return c.includes("бізнес") && c.includes("партнер");
// }

// export function getPaymentMethodRaw(order = {}) {
//   const raw =
//     order?.payment?.method || order?.paymentMethod || order?.pay || "";
//   const v = String(raw).toLowerCase().trim();
//   if (v.includes("invoice") || v.includes("рах")) return "invoice";
//   if (v.includes("card") || v.includes("карт")) return "card";
//   return v || "";
// }

// export function getPaymentMethodLabel(order = {}) {
//   const m = getPaymentMethodRaw(order);
//   if (m === "invoice") return "По рахунку";
//   if (m === "card") return "Картою";
//   return m || "—";
// }

// export function getPaymentProviderLabel(order = {}) {
//   return (
//     order?.payment?.provider ||
//     order?.paymentProvider ||
//     (getPaymentMethodRaw(order) === "invoice" ? "invoice" : "liqpay") ||
//     "—"
//   );
// }

// export function getPaymentStatusRaw(order = {}) {
//   return (
//     order?.payment?.status || order?.paymentStatus || order?.liqpayStatus || ""
//   );
// }

// export function isPaidOrder(order = {}) {
//   if (order?.isPaid === true) return true;
//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
//   return ["paid", "success", "sandbox", "true", "1"].includes(raw);
// }

// export function getPaymentStatusLabel(order = {}) {
//   if (isPaidOrder(order)) return "оплачено";
//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
//   if (!raw) return "не оплачено";
//   if (raw === "pending") return "очікує оплату";
//   if (raw === "invoice_pending") return "очікує рахунок";
//   if (raw === "invoice_created") return "рахунок сформовано";
//   if (raw === "failure" || raw === "error") return "помилка";
//   return raw;
// }

// export function getInvoiceInfo(order = {}) {
//   const invoiceUrl =
//     order?.invoiceUrl ||
//     order?.invoiceMeta?.invoiceUrl ||
//     order?.invoice?.invoiceUrl ||
//     "";

//   const invoiceNumber =
//     order?.invoiceNumber ||
//     order?.invoiceMeta?.invoiceNumber ||
//     order?.invoice?.invoiceNumber ||
//     "";

//   const invoiceDate =
//     order?.invoiceDate ||
//     order?.invoiceMeta?.invoiceDate ||
//     order?.invoice?.invoiceDate ||
//     "";

//   const fileType =
//     order?.invoiceFileType ||
//     order?.invoiceMeta?.fileType ||
//     order?.invoice?.fileType ||
//     (String(invoiceUrl).endsWith(".xlsx") ? "xlsx" : "");

//   return {
//     invoiceUrl: String(invoiceUrl || ""),
//     invoiceNumber: String(invoiceNumber || ""),
//     invoiceDate: String(invoiceDate || ""),
//     fileType: String(fileType || ""),
//   };
// }

// export function getOrderTotal(order = {}) {
//   const candidates = [
//     order?.pricing?.finishPrice,
//     order?.finishPrice,
//     order?.pricing?.totalPrice,
//     order?.totalPrice,
//   ];
//   for (const v of candidates) {
//     const n = Number(v);
//     if (Number.isFinite(n)) return n;
//   }
//   return 0;
// }

// export function getBuyerFullName(order = {}) {
//   return (
//     order?.buyer?.fullName ||
//     joinName(order?.buyer?.name, order?.buyer?.surName) ||
//     order?.userSnapshot?.displayName ||
//     joinName(order?.surName, order?.name, order?.fatherName) ||
//     "—"
//   );
// }

// export function getBuyerPhone(order = {}) {
//   return (
//     order?.buyer?.phone || order?.userSnapshot?.phone || order?.phone || "—"
//   );
// }

// export function getReceiverFullName(order = {}) {
//   if (order?.receiver?.sameAsBuyer === true) return getBuyerFullName(order);
//   return (
//     order?.receiver?.fullName ||
//     joinName(order?.receiver?.name, order?.receiver?.surName) ||
//     joinName(order?.surNameOtr, order?.nameOtr, order?.fatherNameOtr) ||
//     "—"
//   );
// }

// export function getReceiverPhone(order = {}) {
//   if (order?.receiver?.sameAsBuyer === true) return getBuyerPhone(order);
//   return order?.receiver?.phone || order?.phoneOtr || "—";
// }

// export function getDeliveryProviderLabel(order = {}) {
//   return (
//     order?.logistics?.providerLabel ||
//     order?.delivery?.methodName ||
//     order?.delivery?.provider ||
//     "Нова пошта"
//   );
// }

// export function getDeliveryLine(order = {}) {
//   const city = order?.delivery?.cityName || order?.cityName || "";
//   const warehouse =
//     order?.delivery?.warehouse || order?.selectedDepartment || "";
//   const area = order?.delivery?.cityArea || "";
//   const parts = [city, area, warehouse].filter(Boolean);
//   return parts.length ? parts.join(", ") : "—";
// }

// export function isCanceledOrder(order = {}) {
//   if (order?.canceled === true) return true;
//   return getStatus(order) === "Скасовано";
// }

// export function toTimestamp(t) {
//   if (!t) return 0;
//   if (typeof t === "number") return Number.isFinite(t) ? t : 0;
//   if (typeof t === "string") {
//     const p = Date.parse(t);
//     return Number.isFinite(p) ? p : 0;
//   }
//   if (t?.seconds)
//     return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
//   try {
//     const d = new Date(t).getTime();
//     return Number.isFinite(d) ? d : 0;
//   } catch {
//     return 0;
//   }
// }

// export function ts(order = {}) {
//   const candidates = [
//     order?.createdAtClient,
//     order?.createdAtISO,
//     order?.createdAt,
//     order?.date,
//     order?.created_at,
//     order?.created,
//   ];
//   for (const t of candidates) {
//     const parsed = toTimestamp(t);
//     if (parsed > 0) return parsed;
//   }
//   return 0;
// }

// export function fmtDate(ms) {
//   if (!ms) return "—";
//   const d = new Date(ms);
//   return d.toLocaleString("uk-UA", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// export function safeMoney(v) {
//   const n = Number(v || 0);
//   if (!Number.isFinite(n)) return "—";
//   return new Intl.NumberFormat("uk-UA", {
//     style: "currency",
//     currency: "UAH",
//     maximumFractionDigits: 0,
//   }).format(n);
// }

// export function shortId(id = "") {
//   const s = String(id || "");
//   return s.slice(-6) || "—";
// }

// export function dayStart(yyyy_mm_dd) {
//   const d = new Date(`${yyyy_mm_dd}T00:00:00`);
//   return d.getTime();
// }

// export function dayEnd(yyyy_mm_dd) {
//   const d = new Date(`${yyyy_mm_dd}T23:59:59.999`);
//   return d.getTime();
// }
// src/components/OrderList/orderUtils.js

export function parseChoice(rawChoice) {
  try {
    if (Array.isArray(rawChoice)) return rawChoice;
    if (typeof rawChoice === "string") return JSON.parse(rawChoice || "[]");
  } catch (e) {
    console.warn("parseChoice error:", e);
  }
  return [];
}

export function joinName(...parts) {
  return parts
    .map((x) => String(x || "").trim())
    .filter(Boolean)
    .join(" ");
}

export function getStatus(order = {}) {
  return order?.statusFlow?.current || order?.status || "Очікує підтвердження";
}

export function getTtn(order = {}) {
  return order?.ttn || order?.logistics?.ttn || order?.delivery?.ttn || "";
}

export function getUserCategory(order = {}) {
  return order?.userCategory || order?.userSnapshot?.category || "";
}

export function isBusinessPartnerOrder(order = {}) {
  const c = String(getUserCategory(order)).toLowerCase();
  return c.includes("бізнес") && c.includes("партнер");
}

export function getPaymentMethodRaw(order = {}) {
  const raw =
    order?.payment?.method || order?.paymentMethod || order?.pay || "";
  const v = String(raw).toLowerCase().trim();
  if (v.includes("invoice") || v.includes("рах")) return "invoice";
  if (v.includes("card") || v.includes("карт")) return "card";
  return v || "";
}

export function getPaymentMethodLabel(order = {}) {
  const m = getPaymentMethodRaw(order);
  if (m === "invoice") return "По рахунку";
  if (m === "card") return "Картою";
  return m || "—";
}

export function getPaymentProviderLabel(order = {}) {
  return (
    order?.payment?.provider ||
    order?.paymentProvider ||
    (getPaymentMethodRaw(order) === "invoice" ? "invoice" : "liqpay") ||
    "—"
  );
}

export function getPaymentStatusRaw(order = {}) {
  return (
    order?.payment?.status || order?.paymentStatus || order?.liqpayStatus || ""
  );
}

export function isPaidOrder(order = {}) {
  if (order?.isPaid === true) return true;
  const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
  return ["paid", "success", "sandbox", "true", "1"].includes(raw);
}

export function getPaymentStatusLabel(order = {}) {
  if (isPaidOrder(order)) return "оплачено";
  const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
  if (!raw) return "не оплачено";
  if (raw === "pending") return "очікує оплату";
  if (raw === "invoice_pending") return "очікує рахунок";
  if (raw === "invoice_created") return "рахунок сформовано";
  if (raw === "failure" || raw === "error") return "помилка";
  return raw;
}

export function getInvoiceInfo(order = {}) {
  const invoiceUrl =
    order?.invoiceUrl ||
    order?.invoiceMeta?.invoiceUrl ||
    order?.invoice?.invoiceUrl ||
    "";

  const invoiceNumber =
    order?.invoiceNumber ||
    order?.invoiceMeta?.invoiceNumber ||
    order?.invoice?.invoiceNumber ||
    "";

  const invoiceDate =
    order?.invoiceDate ||
    order?.invoiceMeta?.invoiceDate ||
    order?.invoice?.invoiceDate ||
    "";

  const fileType =
    order?.invoiceFileType ||
    order?.invoiceMeta?.fileType ||
    order?.invoice?.fileType ||
    (String(invoiceUrl).endsWith(".xlsx") ? "xlsx" : "");

  return {
    invoiceUrl: String(invoiceUrl || ""),
    invoiceNumber: String(invoiceNumber || ""),
    invoiceDate: String(invoiceDate || ""),
    fileType: String(fileType || ""),
  };
}

export function hasInvoice(order = {}) {
  const invoice = getInvoiceInfo(order);
  return (
    getPaymentMethodRaw(order) === "invoice" ||
    !!invoice.invoiceUrl ||
    !!invoice.invoiceNumber
  );
}

export function getOrderTotal(order = {}) {
  const candidates = [
    order?.pricing?.finishPrice,
    order?.finishPrice,
    order?.pricing?.totalPrice,
    order?.totalPrice,
  ];
  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }
  return 0;
}

export function getBuyerFullName(order = {}) {
  return (
    order?.buyer?.fullName ||
    joinName(order?.buyer?.name, order?.buyer?.surName) ||
    order?.userSnapshot?.displayName ||
    joinName(order?.surName, order?.name, order?.fatherName) ||
    "—"
  );
}

export function getBuyerPhone(order = {}) {
  return (
    order?.buyer?.phone || order?.userSnapshot?.phone || order?.phone || "—"
  );
}

export function getReceiverFullName(order = {}) {
  if (order?.receiver?.sameAsBuyer === true) return getBuyerFullName(order);
  return (
    order?.receiver?.fullName ||
    joinName(order?.receiver?.name, order?.receiver?.surName) ||
    joinName(order?.surNameOtr, order?.nameOtr, order?.fatherNameOtr) ||
    "—"
  );
}

export function getReceiverPhone(order = {}) {
  if (order?.receiver?.sameAsBuyer === true) return getBuyerPhone(order);
  return order?.receiver?.phone || order?.phoneOtr || "—";
}

export function getDeliveryProviderLabel(order = {}) {
  return (
    order?.logistics?.providerLabel ||
    order?.delivery?.methodName ||
    order?.delivery?.provider ||
    "Нова пошта"
  );
}

export function getDeliveryLine(order = {}) {
  const city = order?.delivery?.cityName || order?.cityName || "";
  const warehouse =
    order?.delivery?.warehouse || order?.selectedDepartment || "";
  const area = order?.delivery?.cityArea || "";
  const parts = [city, area, warehouse].filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}

export function isCanceledOrder(order = {}) {
  if (order?.canceled === true) return true;
  return getStatus(order) === "Скасовано";
}

export function getItemFinalUnitPrice(el = {}) {
  const qty = Math.max(1, Number(el?.quantity ?? el?.qty ?? 1) || 1);

  const purchasedUnitPrice = Number(el?.purchasedUnitPrice);
  if (Number.isFinite(purchasedUnitPrice) && purchasedUnitPrice > 0) {
    return purchasedUnitPrice;
  }

  const finalPrice = Number(el?.finalPrice);
  if (Number.isFinite(finalPrice) && finalPrice > 0) {
    return finalPrice;
  }

  const unitPrice = Number(el?.unitPrice);
  if (Number.isFinite(unitPrice) && unitPrice > 0) {
    return unitPrice;
  }

  const lineTotal = Number(el?.lineTotal);
  if (Number.isFinite(lineTotal) && lineTotal > 0) {
    return Number((lineTotal / qty).toFixed(2));
  }

  const price = Number(el?.price);
  if (Number.isFinite(price) && price > 0) {
    return price;
  }

  const promoUnitPrice = Number(el?.promoUnitPrice);
  if (Number.isFinite(promoUnitPrice) && promoUnitPrice > 0) {
    return promoUnitPrice;
  }

  const basePrice = Number(el?.basePrice);
  if (Number.isFinite(basePrice) && basePrice > 0) {
    return basePrice;
  }

  return 0;
}

export function toTimestamp(t) {
  if (!t) return 0;
  if (typeof t === "number") return Number.isFinite(t) ? t : 0;
  if (typeof t === "string") {
    const p = Date.parse(t);
    return Number.isFinite(p) ? p : 0;
  }
  if (t?.seconds)
    return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
  try {
    const d = new Date(t).getTime();
    return Number.isFinite(d) ? d : 0;
  } catch {
    return 0;
  }
}

export function ts(order = {}) {
  const candidates = [
    order?.createdAtClient,
    order?.createdAtISO,
    order?.createdAt,
    order?.date,
    order?.created_at,
    order?.created,
  ];
  for (const t of candidates) {
    const parsed = toTimestamp(t);
    if (parsed > 0) return parsed;
  }
  return 0;
}

export function fmtDate(ms) {
  if (!ms) return "—";
  const d = new Date(ms);
  return d.toLocaleString("uk-UA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function safeMoney(v) {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("uk-UA", {
    style: "currency",
    currency: "UAH",
    maximumFractionDigits: 0,
  }).format(n);
}

export function shortId(id = "") {
  const s = String(id || "");
  return s.slice(-6) || "—";
}

export function dayStart(yyyy_mm_dd) {
  const d = new Date(`${yyyy_mm_dd}T00:00:00`);
  return d.getTime();
}

export function dayEnd(yyyy_mm_dd) {
  const d = new Date(`${yyyy_mm_dd}T23:59:59.999`);
  return d.getTime();
}
